import throttle from 'lodash.throttle'
import debounce from 'lodash.debounce'

export default class ScrollSpy {
  constructor(container, selector = 'a', activeClass = 'active'){
    this.container = container instanceof HTMLElement ? container : document.querySelector(container)
    this.trackers = Array.from(this.container.querySelectorAll(selector))
    // Make smarter
    this.offset = document.querySelector('.site-header').getBoundingClientRect().height;
    this.bodyEl = document.querySelector('body')
    this.activeClass = activeClass

    this.buildTrackingObj()
    this.events()

    this.scrollEvent()
  }

  events() {
    this.scrollEvent = throttle(this.scrollEvent, 100).bind(this)
    this.reinit = debounce(this.reinit, 100).bind(this)

    window.addEventListener('scroll', this.scrollEvent)
    window.addEventListener('resize', this.reinit)
  }

  reinit() {
    this.buildTrackingObj()
    // console.log('reinit');
  }

  scrollEvent(){
    const scrolled = this.bodyEl.scrollTop || document.documentElement.scrollTop
    const threshold = (scrolled + (this.offset + 100))

    for (var key in this.trackingObj) {
      // console.log('checkTracker:', scrolled, key, this.trackingObj[key]);

      if (threshold > key && this.trackingObj.hasOwnProperty(key)) {
        const element = this.trackingObj[key];
        this.updateActive(element);
        // Kill that obj as it's used
        // delete this.trackerObj[key]
      }

    }
  }

  updateActive(element){
    // Can this be smarter?
    this.trackers.forEach(el => {
      if(el === element){
        // console.log('addclass:', el);
        el.classList.add(this.activeClass)
      } else {
        el.classList.remove(this.activeClass)
      }
    })
  }

  buildTrackingObj(){
    this.trackingObj = {}

    this.trackers.forEach(el => {
      const targetString = el.hash;
      console.log(targetString);
      if (targetString && document.querySelector(targetString)) {
      const target = document.querySelector(targetString);
      if (target) {
        const offsetTop = target.offsetTop;
        this.trackingObj[Math.floor(offsetTop)] = el;
      }
      }
    })

    // console.log('trackingObj: ', this.trackingObj);
  }
}
